export default {
	tenantId: "filife_prod",
	appId: "covergo_crm",

	fileSystem: {
		bucketName: "filife-prod-covergo-filesystem"
	}
}
